import "react";
import { ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Events/shared/EventTypeTitle.tsx
var EventTypeTitle = ({ eventType, truncate = true }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames({ truncate }),
		children: [
			/* @__PURE__ */ jsx(ColorSquare, { color: eventType.color }),
			" ",
			eventType.name
		]
	});
};
//#endregion
export { EventTypeTitle };

//# sourceMappingURL=EventTypeTitle.js.map